export const AppConfig = {
    features: {
        showTenantDemoSeed: import.meta.env.VITE_SHOW_TENANT_DEMO_SEED === 'true',
        showApartmentAgreements:
            import.meta.env.VITE_APARTMENT_DETAILS_SHOW_AGREEMENTS === 'true',
        showApartmentTrustees:
            import.meta.env.VITE_APARTMENT_DETAILS_SHOW_TRUSTEES === 'true',
    },
    defaults: {
        version: "1.0.50"
    },
    formats: {
        date: "d MMMM, yyyy",
        time: "HH:mm",
        dateTime: "d MMMM, yyyy HH:mm",
    },
    identity: {
        localStorageTokenKey: "TokenData",
        roles: {
            superAdmin: "SuperAdmin",
            admin: "Admin",
            owner: "Owner",
        },

    },
    stores: {
        preferencesStore: "preferences-store",
    },
    mediaQueries: {
        mobile: "(max-width: 640px)",
    }
};
